import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="border-y border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium uppercase tracking-wider text-primary-600">常见问题</span>
          <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">你可能关心的问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于免费阅读、分类、榜单与阅读体验的常见解答。</p>
        </div>
        <div className="mt-10 space-y-3">
          {faqItems.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-200" : "border-background-200/70"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{item.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-transform ${
                      isOpen ? "rotate-180 text-primary-600" : ""
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg" />
                  </span>
                </button>
                {isOpen && (
                  <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}